import {isAvailable} from '../../referral';
import {ReferralWithMyOrgOffers} from '../hook/useReferralQueryForProvider$';

export const canSubmitNewOffer = (referral: Partial<ReferralWithMyOrgOffers>) =>
    isAvailable(referral) &&
    (referral.myOrgSubmittedOffers?.length ?? 0) === 0;

export const canViewSubmittedOffer = (referral: Partial<ReferralWithMyOrgOffers>) =>
    (referral.myOrgSubmittedOffers?.length ?? 0) > 0;

export const canViewAcceptedOffer = (referral: Partial<ReferralWithMyOrgOffers>) =>
    (referral.myOrgAcceptedOffers?.length ?? 0) > 0;
